// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_60-2";
export var blackBorderOnHover = "_60-7";
export var cell = "_60-6";
export var cellContainer = "_60-3";
export var checked = "_60-8";
export var disabled = "_60-5";
export var featuredIconCellContainer = "_60-9";
export var featuredIconTextContainer = "_60-b";
export var featuredIconWrapper = "_60-a";
export var noBorder = "_60-c";
export var orangeSelectedRow = "_dw-3";
export var overflowableText = "_60-0";
export var overflowableTextContainer = "_60-1";
export var row = "_5z-0";
export var rowCheckboxCell = "_60-4";
export var selectableTable = "_dw-2";